import { useState } from "react";
import { DeleteTeam } from "../../../api/Team/DeleteTeamMember";
import { toast } from "react-toastify";
import TrashIcon from "../../Icons/TrashIcon";
import DeleteModal from "../../Shared/DeleteModal";
const TeamMemberCard = ({ teamId, img, name, title, email }: { img?: string; name?: string; title?: string; email?: string; teamId: string; }) => {

    const handleDelete = async (id:string) => {
        await DeleteTeam(id);
        toast.success("Team Member deleted successfully");
    };
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="shadow-sm bg-white rounded-xl p-8 flex flex-col items-center justify-center h-[289px] bg-teamPattern relative">
            <img src={img} className="size-[110px] rounded-full object-cover object-[75%_25%] mb-6" alt="" />
            <h1 className="mb-1">{name}</h1>
            <p className="mb-2.5">{title}</p>
            <p className="text-xs">{email}</p>
            <button onClick={() => setIsOpen(true)} className="absolute text-[#EF3826] top-2 right-2"><TrashIcon /></button>
            <DeleteModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                mutationFn={handleDelete}
                itemId={teamId}
                queryKey="teams"
            />

        </div>
    )
}

export default TeamMemberCard